import axios from 'axios'
import ResourceModelBase from 'odd-resource_model'
import FetchingDataOptionsService from 'odd-fetching_data_options_service'

const OPTIONS = {
  apiPath: '/api',
  apiVersion: 'v1',
  scope: 'web',
  resourceType: 'promotional_articles',
  attributes: [
    'category_ids',
    'content',
    'cover',
    'mobile_cover',
    'created_at',
    'id',
    'meta_description',
    'meta_keywords',
    'meta_title',
    'published_at',
    'ended_at',
    'slug',
    'title',
    'view_count',
    'is_available',
  ],
  editableAttributes: [
    'title',
    'content',
    'category_ids',
    'meta_title',
    'meta_keywords',
    'meta_description',
    'slug',
    'published_at',
    'ended_at',
    'uploaded_attachment_ids',
    'is_available',
  ],
}

export default class PromotionalArticle extends ResourceModelBase {
  constructor(attributes = {}) {
    super(OPTIONS, attributes)
  }

  static all(options = {}) {
    let queryString = FetchingDataOptionsService.call(options)

    if (options.usage) queryString += `&usage=${options.usage}`

    return axios.get(`${new this().apiBasePath()}?${queryString}`)
  }

  // extra methods or helpers here...

  toggleAvailability() {
    return axios.put(`${this.apiBasePath()}/${this.id}/toggle_availability`)
  }

  saveWithFormData(formData) {
    if (this.isNewRecord()) {
      return axios.post(this.apiBasePath(), formData)
    }
    return axios.put(`${this.apiBasePath()}/${this.id}`, formData)
  }
}
